/**
 * Tunable values for base layer tile timeouts and the automatic fallback.
 * Edit here to adjust; there is no server-side configuration for these.
 */
export const BaseLayerHealthSettings = {
    /**
     * A tile request with no response at all after this long is aborted and counted as a
     * failure: the server is treated as dead. OpenLayers loads at most 16 tiles at once
     * across the whole map, so requests stalled on a dead server (the browser's own
     * connect timeout is ~20s) hold up every other layer until they end.
     * Only the wait for the response counts: once the server answers, a slow download is
     * allowed (tileDownloadTimeoutMs), so a slow mobile connection is not mistaken for an outage.
     */
    tileConnectTimeoutMs: 8000,

    /** Once the server has responded, the tile body must finish downloading within this. */
    tileDownloadTimeoutMs: 30000,

    /**
     * Consecutive tile failures (no response or network error, with no successful tile in
     * between) that mark the visible base layer as unavailable.
     */
    failureThreshold: 4,

    /**
     * Layers (the radio/layer "name" values) to fall back to, in order, when the
     * visible base layer is unavailable. OpenData is hosted on esdm.co.uk too, so
     * the MapTiler layer is there for a wider outage.
     */
    fallbackLayerNames: ["OpenData", "OS_One_Inch_GB_Hills"],

    /** How long the toast stays visible. */
    toastDurationMs: 8000
};
